import { useGetGiftCardV3 } from '@ordr-as/ordr-service-types/epos';
import { isValidNumericLocationId } from '../utils/locationId';

export const useGiftCardSearch = (locationId: number, query: string, giftCardSource: 'INTERNAL' | 'EXTERNAL') => {
  const { queryKey: _queryKey, ...result } = useGetGiftCardV3(
    locationId,
    { query, source: giftCardSource },
    {
      query: {
        enabled: isValidNumericLocationId(locationId),
      },
    }
  );
  return result;
};
